import moment from 'moment';

export const createWaterfall = (
    itemPositions,
    currentDate,
    positionsEntities,
    settings,
    lastLaborPositionGuid,
    plannedMhd,
    remainder,
    long,
    charters = []
) => {
    // const currentPositions = [...itemPositions];
    const labors = itemPositions.filter((position) => position.type === 'labor');
    const MHDs = itemPositions.filter((position) => position.type !== 'labor');
    const result = { ...positionsEntities };

    const connections = [];

    const firstPositionGuid = itemPositions[0].guid;

    const resultMHDPositions = [];

    for (let i = 0; i < labors.length; i++) {
        if (i !== labors.length - 1) {
            connections.push({
                positionFromGuid: labors[i].guid,
                positionToGuid: labors[i + 1].guid,
                connectionType: 0,
            });

            const connectionsFrom = [
                ...labors[i].connections,
                { from: labors[i].guid, to: labors[i + 1].guid, type: 0 },
            ];

            const connectionsTo = [
                ...labors[i + 1].connections,
                { from: labors[i].guid, to: labors[i + 1].guid, type: 0 },
            ];

            const fromPosition = {
                ...labors[i],
                connections: connectionsFrom,
            };
            const toPosition = {
                ...labors[i + 1],
                connections: connectionsTo,
            };
            labors[i] = fromPosition;
            labors[i + 1] = toPosition;
        }
    }

    labors.forEach((position) => {
        result[position.guid] = position;
    });

    // resultMHDPositions.forEach((position) => {
    //     if (settings.isShowMHD) {
    //         result[position.guid] = position;
    //     }
    // });

    itemPositions.forEach(({ guid }) => {
        if (positionsEntities[guid].type === 'labor') {
            const isLastPosition = lastLaborPositionGuid === guid;

            const countDays = isLastPosition ? remainder + long : long;
            const planedPosition = {
                days_count: `${countDays}`,
                start_date: currentDate,
                end_date: moment(currentDate)
                    .add(countDays - 1, 'days')
                    .format(),
            };
            currentDate = moment(currentDate).add(long, 'days').format();

            const updatedPosition = {
                ...result[guid],
                planned: planedPosition,
            };

            result[guid] = updatedPosition;
        } else {
            const updatePosition = {
                ...result[guid],
                planned: plannedMhd,
            };

            if (settings.isShowMHD) result[guid] = updatePosition;
        }
    });

    if (settings.isShowMHD) {
        charters.forEach((charter) => {
            const charterPositions = charter.children.map((guid) => result[guid]);
            const charterMHDPositions = charterPositions.filter(
                (position) => position?.type !== 'labor'
            );
            const charterLaborPositions = charterPositions
                .filter((position) => position?.type === 'labor')
                .sort(
                    (positionA, positionB) =>
                        moment(positionA?.planned.start_date).valueOf() -
                        moment(positionB?.planned.start_date).valueOf()
                );
            if (charterLaborPositions.length) {
                charterMHDPositions.forEach((position) => {
                    if (position) {
                        const addDaysValue =
                            +settings.daysMHD > charterLaborPositions.length
                                ? charterLaborPositions.length
                                : +plannedMhd.days_count;

                        const planned = {
                            days_count: `${addDaysValue}`,
                            start_date: moment(
                                charterLaborPositions[0].planned.start_date
                            ).format(),
                            end_date: moment(charterLaborPositions[0].planned.start_date)
                                .add(addDaysValue - 1)
                                .format(),
                        };

                        result[position.guid] = { ...result[position.guid], planned };
                    }
                });
            }
        });
    }

    return { updatedEntities: result, connections };
};
